import IcClose from './IcClose'

export default IcClose
